import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AppConfig } from '®shared/config/app-config';
import { TenantType } from '®shared/tenant';

import { CurrentUserService } from '../current-user';
import { WindowShimService } from '../window-shim';

@Injectable({
  providedIn: 'root',
})
export class ProductFruitsService implements OnDestroy {
  constructor(
    private window: WindowShimService,
    private currentUserService: CurrentUserService,
    private appConfig: AppConfig,
  ) {}

  private currentUserSubscription: Subscription;

  ngOnDestroy(): void {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }

  init() {
    if (this.window.$productFruits) {
      this.currentUserSubscription = this.currentUserService
        .getCurrentUser()
        .subscribe(currentUser => {
          const { oauthUser } = currentUser;
          const { isAnonymous } = oauthUser;

          if (!isAnonymous && currentUser.eligibleForProductFruits) {
            const userGuid = oauthUser.guid;
            const { tenant } = this.appConfig;
            if (userGuid) {
              this.window.$productFruits.push([
                'init',
                'BVNnBv6mgLgXytk2',
                'en',
                {
                  username: userGuid,
                  props: {
                    tenant: tenant.shortCode,
                    tenantType: tenant.featureFlags.isCourseFlowTenancy
                      ? TenantType.COURSEFLOW
                      : TenantType.ASPIRE,
                    jobRole: currentUser.tarlUser?.job_role_description || null,
                  },
                },
              ]);
            }
          }
        });
    }
  }
}
